module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_47.17d0b447.jpg";